import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import * as React from 'react';
import { compose, lifecycle, pure, withStateHandlers } from 'recompose';
import { FontIcon } from '../FontIcon';
import styles from './CarouselCardStyle';
const wrapNumber = (value, limit) => ((value % limit) + limit) % limit;
const CarouselCard = ({ children, classes, current, wrap, setNext, setPrev, noPaper, hideDots, testId = 'CarouselCard', }) => {
    const total = React.Children.count(children);
    const isFirst = !wrap && current === 0;
    const isLast = !wrap && current === total - 1;
    const isDisabled = total === 1;
    const switcher = (React.createElement(React.Fragment, null,
        React.createElement("span", { "data-testid": `${testId}-prev`, onClick: setPrev, className: classNames(classes.control, {
                [classes.controlDisabled]: isDisabled || isFirst,
            }) },
            React.createElement(FontIcon, { className: classes.controlIcon, iconName: "chevron-left" })),
        React.createElement("div", { className: classNames(classes.content, { [classes.contentVerticalPadding]: !noPaper }) }, React.Children.map(children, (child, i) => (i === current ? child : null))),
        React.createElement("span", { "data-testid": `${testId}-next`, onClick: setNext, className: classNames(classes.control, {
                [classes.controlDisabled]: isDisabled || isLast,
            }) },
            React.createElement(FontIcon, { className: classes.controlIcon, iconName: "chevron-right" }))));
    return (React.createElement(React.Fragment, null,
        noPaper ? (React.createElement("div", { className: classes.root }, switcher)) : (React.createElement(Paper, { className: classes.root }, switcher)),
        hideDots ? null : (React.createElement("div", { className: classes.indicators }, new Array(total).fill(null).map((x, i) => (React.createElement("span", { key: i, className: classNames(classes.indicatorDot, { [classes.indicatorDotActive]: i === current }) })))))));
};
const ComposedCarouselCard = compose(pure, withStyles(styles, { withTheme: true }), withStateHandlers(({ index }) => ({
    current: index || 0,
}), {
    setNext: ({ current }, { wrap, children, onChange = () => null }) => () => {
        const total = React.Children.count(children);
        const nextIdx = wrap ? wrapNumber(current + 1, total) : Math.min(current + 1, total - 1);
        if (nextIdx !== current) {
            onChange(nextIdx);
        }
        return {
            current: nextIdx,
        };
    },
    setPrev: ({ current }, { wrap, children, onChange = () => null }) => () => {
        const total = React.Children.count(children);
        const prevIdx = wrap ? wrapNumber(current - 1, total) : Math.max(current - 1, 0);
        if (prevIdx !== current) {
            onChange(prevIdx);
        }
        return {
            current: prevIdx,
        };
    },
    setIndex: (_, { children }) => (index) => {
        const total = React.Children.count(children);
        return {
            current: Math.max(0, Math.min(index, Math.max(total - 1, 0))),
        };
    },
}), lifecycle({
    componentDidUpdate(prevProps) {
        if (typeof this.props.index === 'number' &&
            prevProps.index !== this.props.index &&
            this.props.index !== this.props.current) {
            this.props.setIndex(this.props.index);
        }
    },
}))(CarouselCard);
ComposedCarouselCard.displayName = 'CarouselCard';
export default ComposedCarouselCard;
//# sourceMappingURL=CarouselCard.js.map